import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { defaultDateTimeFormat } from '../constants/dates';

dayjs.extend(utc);

export const getCurrentYear = (): number => {
  return new Date().getFullYear();
};

export const modifiedDate = (date: Date, customFormat?: string): string => {
  return dayjs
    .utc(date)
    .local()
    .format(customFormat || defaultDateTimeFormat);
};
